import { HlaWayType } from "../../hla/models/HlaWay";

export type CompositeCategoryItem = { type: string; class: string };

export type CompositeCategory = {
  name: HlaWayType;
  items: CompositeCategoryItem[];
  totalFeatures: number;
  color: string;
  enabled: boolean;
};

export const compositeColors: Record<HlaWayType, string> = {
  Cycleway: "#f82c2c",
  Motorway: "#e56700",
  Primary: "#e1aa12",
  Secondary: "#d3e532",
  Tertiary: "#6aea37",
  Service: "#1bbb8e",
  Unclassified: "#359de7",
  Pedestrian: "#1929d7",
  Sidewalk: "#8237f3",
  FootPath: "#bb24c0",
  Platform: "#8c1313",
};

export const buildDefaultCategories = () => {
  return Object.values(HlaWayType).map((name) => ({
    name: name,
    items: [],
    color: compositeColors[name],
    totalFeatures: 0,
    enabled: name === HlaWayType.Cycleway,
  }));
};
